const salesStates = [
  {
    class: '',
    id: '',
    name: 'Todos los estados'
  },

  {
    class: 'text-color-danger',
    id: 9,
    name: 'Abandonada'
  },

  {
    class: 'text-color-success',
    id: 1,
    name: 'Activa'
  },

  {
    class: 'text-color-info',
    id: 6,
    name: 'Anulada'
  },

  {
    class: 'text-color-danger',
    id: 5,
    name: 'Cancelada'
  },

  {
    class: 'text-color-success',
    id: 4,
    name: 'Completada'
  },

  {
    class: 'text-color-info',
    id: 7,
    name: 'En Prueba'
  },

  {
    class: 'text-color-info',
    id: 0,
    name: 'Pendiente'
  },
  {
    class: 'text-color-info',
    id: 8,
    name: 'Reemplazada'
  },
  {
    class: 'text-color-danger',
    id: 3,
    name: 'Suspendida'
  },

  {
    class: 'text-color-warning',
    id: 2,
    name: 'Vencida'
  }
]

export default salesStates
